<template>
  <div>
    <div class="download
      topViolet bottomVert padding10">
      <div>
        <a ref="lienDownload"></a>
        <a @click="exportOpportunite()"
          class="leftViolet topViolet bottomViolet colortext">
          <b-icon icon="file-download"></b-icon>
          Télécharger la proposition </a>
      </div>
    </div>
  </div>
</template>

<script>
import gestionErreur from '@/services/general/gestionErreur';
import { getOpportunitePdf } from '@/api/opportunite/index';

export default {
  name: 'telecharger',
  methods: {
    async exportOpportunite() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const link = this.$refs.lienDownload;
        const response = await getOpportunitePdf(this.$route.params.id);
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        gestionErreur('Erreur serveur');
        throw (e);
      }
    },
  },

};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/composants/telecharger.vue